import Injectable from '@/modules/shared/domain/di/injectable';
import { CreatePhoneRepository } from '../../../domain/repository/create-phone-repository';

@Injectable()
export default class CreatePhoneDummyRepository implements CreatePhoneRepository {
  execute() {
    return Promise.resolve();
  }
}
